// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__3v0HM","fadeIn":"Label_fadeIn__Rn-1r","fadeOut":"Label_fadeOut__kUJP0"};